// External Dependencies:
import React from 'react'
import { browserHistory } from 'react-router'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageEvents from '../page/PageEvents'
import Slider from 'components/Slider/Slider'
import Subscribe from 'components/Subscribe/Subscribe'

class HomeContentFrench extends React.Component {
	render() {
		document.title = siteData.site_name
		const imgURL = siteData.images_url + 'home/'

		return (
			<div>
				<PageEvents />

				<div className="wide-sections">
					<div className="wide-section wide-section-home-split">
						<div>
							<Link to="/fr/discipulat/">
								<img src={ siteData.images_url + 'home/feature/journey.jpg' } alt="" />

								<span className="-text">
									Discipulat
								</span>
							</Link>
						</div>

						<div>
							<Link to="/fr/outils/">
								<img src={ siteData.images_url + 'home/feature/ministry.jpg' } alt="" />

								<span className="-text">
									Outils
								</span>
							</Link>
						</div>
					</div>

					<Subscribe />
				</div>
			</div>
		)
	}
}

export default HomeContentFrench



// WEBPACK FOOTER //
// ./views/main/home/HomeContentFrench.jsx